import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const ExaminationNotice = () => {
  return <SingleContentPage title="Examination Notice" moduleKey="examination-notice" />;
};

export default ExaminationNotice;
